module.exports = __webpack_public_path__ + "img/3.5da780d3.jpg";